// extracted by mini-css-extract-plugin
export default {"archive":"styles_archive__-6uHo","archive__box":"styles_archive__box__afVRw","archive__text":"styles_archive__text__fH8-b"};